import React from 'react'
import RuntimeImage from './img/runtime-platform-1.webp'
import './content.scss'

export default function EmeraldRuntimeSection() {
  return (
    <div className="clir">
      <div className="container">
        <div className="clir__block">
          <div className="clir__left">
            <h2 className="white">
              Dealmed Runtime™ A Full Online System to Manage and Place Orders.
            </h2>

            <p className="clir__desc">
              Open a Dealmed Runtime™ account to unlock services and tools that provide better
              performance, efficiency and patient care.
            </p>

            <a href="/register" className="home-btn home-btn--grey home-btn--small">
              GET STARTED TODAY
            </a>
          </div>

          <div className="clir__right">
            <img src={RuntimeImage} alt="dealmed runtime" loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  )
}
